export default function () {
  const widgetName = 'hotButtons';
  const widgetOpts = hotButtonsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customWidget() {
        $(`#${widgetName} .card-widget-item`).each(function (i) {
          $(this).removeAttr('target')

          if (!slide.items[i].URL) {
            $(this).css({
              'cursor': 'default',
              'filter': 'none'
            })
          }
        })
      }

      customWidget()

    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
      text: ''
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });
}